import {logger, meta, MetaObject, TocEntry} from 'tizra'
import {useApi} from './useApi'

const log = logger('quickstart/hooks/useOEmbed')

interface UseOEmbedProps {
  enabled?: boolean
  metaObj?: MetaObject | TocEntry
  width?: number
}

type OEmbedResponse = ({html: string} | {html: never}) & {
  thumbnail_url_with_play_button?: string
  thumbnail_url?: string
}

type UseOEmbedReturn =
  | null // not available for this object
  | undefined // don't know yet
  | OEmbedResponse

export const useOEmbed = ({
  enabled = true,
  metaObj,
  width,
}: UseOEmbedProps): UseOEmbedReturn => {
  const hasOEmbed = meta.hasOEmbed(metaObj)

  // Will return undefined while disabled or fetching, then null or
  // OEmbedResponse.
  const oEmbed = useApi.oEmbedProxy(
    enabled &&
      metaObj &&
      hasOEmbed &&
      'tizraId' in metaObj && {
        tizraId: metaObj.tizraId,
        width: meta.roundWidth(width),
      },
  ).data as UseOEmbedReturn

  // If we know it's not oEmbed, return null even if the API response is
  // undefined ("pending"). This gives the green light to callers to fall back
  // to something else.
  return hasOEmbed === false ? null : oEmbed
}
